<template>
<div class="chapter">
<div class="inner_page">
<div class="C1184">
<p class="C1185"><strong><span id="page_9">PART </span>ONE </strong></p>
<p class="P80"><em>Mapping the Past </em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_PART_ONE.vue?dbf2793e